import { Link } from "react-router-dom";
import { COMPANY, openCookiePrefs } from "@/lib/legal";

const LINKS = [["/privacy", "Privacy Policy", "privacy"], ["/cookie", "Cookie Policy", "cookie"], ["/termini", "Termini e condizioni", "terms"]];

export const LegalFooter = () => (
  <footer className="border-t bg-[#0f1710] text-slate-400" data-testid="legal-footer">
    <div className="mx-auto flex max-w-6xl flex-col gap-4 px-4 py-8 text-xs sm:px-6 md:flex-row md:items-center md:justify-between">
      <p data-testid="footer-company">
        <b className="text-slate-200">{COMPANY.name}</b> · {COMPANY.address} · P.IVA {COMPANY.vat}
      </p>
      <nav className="flex flex-wrap gap-x-5 gap-y-2">
        {LINKS.map(([to, label, id]) => (
          <Link key={to} to={to} className="transition-colors hover:text-[#a2ca6b]" data-testid={`footer-${id}-link`}>{label}</Link>
        ))}
        <button onClick={openCookiePrefs} className="transition-colors hover:text-[#a2ca6b]" data-testid="footer-cookie-prefs-button">Preferenze cookie</button>
      </nav>
    </div>
  </footer>
);
